import { SidebarProvider, useSidebar } from "../../../context/SidebarContext";
import { Outlet } from "react-router-dom";
import SuperAdminAppHeader from "./SuperAdminAppHeader";
import SuperAdminBackdrop from "./SuperAdminBackdrop";
import SuperAdminAppSidebar from "./SuperAdminAppSidebar";
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../../redux/slices/superAdminSlice';

const LayoutContent = () => {
  const { isExpanded, isHovered, isMobileOpen } = useSidebar();

  return (
    <div className="min-h-screen xl:flex">
      <div>
        <SuperAdminAppSidebar />
        <SuperAdminBackdrop />
      </div>
      <div
        className={`flex-1 transition-all duration-300 ease-in-out ${
          isExpanded || isHovered ? "lg:ml-[290px]" : "lg:ml-[90px]"
        } ${isMobileOpen ? "ml-0" : ""}`}
      >
        <SuperAdminAppHeader />
        <div className="p-4 mx-auto max-w-(--breakpoint-2xl) md:p-6">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

const SuperAdminAppLayout = () => {
  return (
    <SidebarProvider>
      <LayoutContent />
    </SidebarProvider>
  );
};

export default SuperAdminAppLayout;
